import React, {Component} from 'react';
import {connect} from 'react-redux';
import {initializeConfigurator} from "../actions/AppInit.Configurator";
import ReactTooltip from "react-tooltip";
import ArticleConfigurator from "../containers/configuration/configurator/ArticleConfigurator";
import {_configuratorMode} from "../selectors/GetParam";
import AppPreloader from "../components/AppPreloader";
import {ARTICLE_CONFIGURATOR_LAYOUT_AGENCY, ARTICLE_CONFIGURATOR_LAYOUT_WEBSITE, ARTICLE_CONFIGURATOR_MODE_SHARED, ARTICLE_TYPE_CMS} from "../constants/General";

function mapStateToProps(state) {
    return {
        appInitialized: state.appState.isInitialized
    };
}

function mapDispatchToProps(dispatch) {
    return {
        initializeConfigurator: () => {
            dispatch(initializeConfigurator())
        }
    };
}

class ArticleConfiguratorApp extends Component {

    componentDidMount() {

        setTimeout(() => {
            ReactTooltip.rebuild();
        }, 1000);

        this.props.initializeConfigurator()

    }

    render() {
        return (
            <div>
                <ReactTooltip className="global-tooltip" effect="float" type="light" border={true} multiline={true} id="global" getContent={dataTip => dataTip}/>
                {this.props.appInitialized ?
                    <ArticleConfigurator
                        hidePersonalization={true}
                        hideBackup={_configuratorMode === ARTICLE_CONFIGURATOR_MODE_SHARED}
                        hideAddons={true}
                        connectToCart={false}
                        forceDefaultOnTypeSwitch={true}
                        mode={_configuratorMode}
                        layout={_configuratorMode === 'shared' ? ARTICLE_CONFIGURATOR_LAYOUT_AGENCY :  ARTICLE_CONFIGURATOR_LAYOUT_WEBSITE}
                    />
                    :  <AppPreloader label=""/>}
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ArticleConfiguratorApp);



/** WEBPACK FOOTER **
 ** ./src/app/ArticleConfiguratorApp.js
 **/